import {
  getKeys
} from '../helper/index.js';

let nodeIDCounter = 0;

const Node = function(data, key, parent) {
  this.children = {};
  this.data = data;
  this.id = nodeIDCounter++;
  this.key = key;
  this.parent = parent;
};

Node.prototype = {
  addChild: function(path, data) {
    const keys = getKeys(path);

    let cur = this;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      let next = cur.children[key];

      // missing node
      if (!next) {
        next = new Node(null, key, cur);
        cur.children[key] = next;
      }
      cur = next;
    }

    cur.data = data;

    return cur;
  },

  remove: function() {
    if (this.parent) {
      delete this.parent.children[this.key];
    }
  },

  isLeaf: function() {
    return Object.keys(this.children).length === 0;
  },

  getLeaves: function() {
    if (this.isLeaf()) {
      return [this];
    }

    let leaves = [];
    for (let k in this.children) {
      leaves = leaves.concat(this.children[k].getLeaves());
    }

    return leaves;
  },

  getPaths: function(prefix = [], ans = []) {
    if (this.isLeaf()) {
      ans.push(prefix.join('.'));
      return;
    }

    for (let k in this.children) {
      prefix.push(k);
      this.children[k].getPaths(prefix, ans);
      prefix.pop();
    }

    return ans;
  },

  findNode: function(path) {
    const keys = getKeys(path);
    let cur = this;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      cur = cur.children[key];
      if (!cur) return null;
    }
    return cur;
  },

  findNodeWithDefault: function(path, defData) {
    let node = this.findNode(path);
    if (!node) {
      node = this.addChild(path, defData);
    }
    return node;
  },

  // find node in subtree
  visitNodes: function(prefix, handler) {
    visitTree(this.findNode(prefix), handler);
  }
};

const visitTree = function(node, handler) {
  if (node === null) return;

  handler(node);

  for (let key in node.children) {
    visitTree(node.children[key], handler);
  }
};

const createTrie = () => {
  return new Node(null, null, null);
};

export {
  createTrie,
  Node,
};
